import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {ApiResponse} from '../../shared/interfaces/api-response';
import {Company} from './interfaces/company';
import {CompanyChartData} from './interfaces/company-chart-data';
import { environment } from '../../../environments/environment';
declare var pqCachedToken: any;
declare var window: any;
@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

  constructor(private http: HttpClient) {
  }

  public getCompanies(withProperties = false): Observable<ApiResponse<CompanyIndexItem[]>> {
    return this.http.get<ApiResponse<CompanyIndexItem[]>>(`${environment.domain}/api/v1/companies${'?cordova=' + (!!window.cordova ? '1' : '0') + '&token=' + pqCachedToken}&withProperties=${withProperties}`);
  }

  public createCompany(company: Company): Observable<ApiResponse<Company>> {
    return this.http.post<ApiResponse<Company>>(`${environment.domain}/api/v1/companies${'?cordova=' + (!!window.cordova ? '1' : '0') + '&token=' + pqCachedToken}`, company);
  }

  public getCompany(id: number): Observable<ApiResponse<Company>> {
    return this.http.get<ApiResponse<Company>>(`${environment.domain}/api/v1/companies/${id}${'?cordova=' + (!!window.cordova ? '1' : '0') + '&token=' + pqCachedToken}`);
  }

  public getCompanyCharts(id: number): Observable<ApiResponse<CompanyChartData>> {
    return this.http.get<ApiResponse<CompanyChartData>>(`${environment.domain}/api/v1/companies/${id}/company-charts${'?cordova=' + (!!window.cordova ? '1' : '0') + '&token=' + pqCachedToken}`);
  }

  public getFilteredCompany(id: number, data): Observable<ApiResponse<Company>> {
    return this.http.post<ApiResponse<Company>>(`${environment.domain}/api/v1/companies/${id}/filter`, data);
  }
}

export interface CompanyIndexItem {
  address: string;
  id: number;
  manager_setting_presets: any[];
  name: string;
  property_ids: number[];
}
